import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LinkOrderFulfillmentPicturesMutationVariables = Types.Exact<{
  order_fulfillment_id: Types.Scalars['ID'];
  picture_ids: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;


export type LinkOrderFulfillmentPicturesMutation = { __typename?: 'Mutation', linkOrderFulfillmentPictures: number };


export const LinkOrderFulfillmentPicturesDocument = gql`
    mutation LinkOrderFulfillmentPictures($order_fulfillment_id: ID!, $picture_ids: [ID!]!) {
  linkOrderFulfillmentPictures(
    order_fulfillment_id: $order_fulfillment_id
    picture_ids: $picture_ids
  )
}
    `;
export type LinkOrderFulfillmentPicturesMutationFn = Apollo.MutationFunction<LinkOrderFulfillmentPicturesMutation, LinkOrderFulfillmentPicturesMutationVariables>;

/**
 * __useLinkOrderFulfillmentPicturesMutation__
 *
 * To run a mutation, you first call `useLinkOrderFulfillmentPicturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkOrderFulfillmentPicturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkOrderFulfillmentPicturesMutation, { data, loading, error }] = useLinkOrderFulfillmentPicturesMutation({
 *   variables: {
 *      order_fulfillment_id: // value for 'order_fulfillment_id'
 *      picture_ids: // value for 'picture_ids'
 *   },
 * });
 */
export function useLinkOrderFulfillmentPicturesMutation(baseOptions?: Apollo.MutationHookOptions<LinkOrderFulfillmentPicturesMutation, LinkOrderFulfillmentPicturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkOrderFulfillmentPicturesMutation, LinkOrderFulfillmentPicturesMutationVariables>(LinkOrderFulfillmentPicturesDocument, options);
      }
export type LinkOrderFulfillmentPicturesMutationHookResult = ReturnType<typeof useLinkOrderFulfillmentPicturesMutation>;
export type LinkOrderFulfillmentPicturesMutationResult = Apollo.MutationResult<LinkOrderFulfillmentPicturesMutation>;
export type LinkOrderFulfillmentPicturesMutationOptions = Apollo.BaseMutationOptions<LinkOrderFulfillmentPicturesMutation, LinkOrderFulfillmentPicturesMutationVariables>;